
import { put, takeLatest } from "redux-saga/effects";
import axiosCustom from '../../../components/common/apiConfig';
import { handleNotificationAlertTrySelect , handleNotificationAlertCatch } from "../../../components/method/handleNotificationAlert";

export const actionTypes = {
    deceased_customer_select_get_kyc_profile_Select: "[deceased_customer_select_get_kyc_profile_Select] Action",
    deceased_customer_select_get_kyc_profile_SelectAsync: "[deceased_customer_select_get_kyc_profile_SelectAsync] Action",
    deceased_customer_select_get_kyc_profile_Remove: "[deceased_customer_select_get_kyc_profile_Remove] Action",
    deceased_customer_select_get_kyc_profile_Loading: "[deceased_customer_select_get_kyc_profile_Loading] Action",
};

const initialState = {
    data: {},
    hire_info:null,
    isOk: false,
    loading:false,
    member_id:null
};


export const reducer_deceased_customer_get_kyc_profile = (state = initialState, { type, payload }) => {
    switch (type) {
        case actionTypes.deceased_customer_select_get_kyc_profile_Select:
            return {
                ...state,
                data: payload?.hits?.hits?.[0] ? payload?.hits?.hits?.[0] : [],
                hire_info:payload?.hits?.hire_info,
                isOk: true,
                member_id:payload?.member_id
            }
            case actionTypes.deceased_customer_select_get_kyc_profile_Loading:
            return {
                ...state,
                loading: payload,
            }
            case actionTypes.deceased_customer_select_get_kyc_profile_Remove:
                return initialState
            default:
                return state
    }
}

function* handleWorker({ payload }) {
    
    yield put({ type: actionTypes.deceased_customer_select_get_kyc_profile_Loading, payload:true })
    let config = {
        url: "insert_request",
    }

    let data = {
        table: "deceased_customer",
        method_type: "get_profile",
        data: payload ? payload : {}
    } 


    try {
        let res = yield axiosCustom(config, data)
        let isOk = handleNotificationAlertTrySelect(res)
        if (!isOk) return

        yield put({ type: actionTypes.deceased_customer_select_get_kyc_profile_Select, payload: res?.data?.response?.data})


    } catch  {
        handleNotificationAlertCatch()
    }
    finally{
        yield put({ type: actionTypes.deceased_customer_select_get_kyc_profile_Loading, payload:false })
    }


}


export function*  worker_deceased_customer_get_kyc_profile () {

    yield takeLatest(actionTypes.deceased_customer_select_get_kyc_profile_SelectAsync, handleWorker)
}